export const cityCreationPayload = (data) => {
  let objectTemp = {
    name: data.name,
    province_id: data?.province_id,
  };

  return objectTemp;
};

export const cityUpdatePayload = (data) => {
  let objectTemp = {
    name: data.name,
    province_id: data?.province_id,
  };

  return objectTemp;
};
